import { JsonObject } from '@backstage/types';
import {
  StepConnector,
  StepLabel,
  Step as StepUI,
  Stepper,
  Typography,
  useTheme,
} from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import DescriptionIcon from '@material-ui/icons/Description';
import Edit from '@material-ui/icons/Edit';
import { FC, MutableRefObject } from 'react';
import { AdditionalStep, Step } from '../MultiStepJsonForm/utils';

interface StepperElementProps {
  steps: Step[];
  additionalSteps?: AdditionalStep[];
  currentStep: Step | AdditionalStep | null;
  rootStepperStyle?: JsonObject;
  activeStep: number;
  ref: MutableRefObject<any>;
  setActiveStep: (index: number) => void;
  isCollapsed?: boolean;
}

export const StepperElement: FC<StepperElementProps> = ({
  steps,
  additionalSteps,
  currentStep,
  rootStepperStyle,
  activeStep,
  setActiveStep,
  ref,
  isCollapsed,
}) => {
  const theme = useTheme();

  const { title: additionalStepTitle } = additionalSteps?.[0] || { title: '' };
  const isTitleClickable = true;
  const additionalStep = (
    <StepUI
      key={additionalStepTitle}
      active={currentStep?.title === additionalStepTitle}
    >
      <StepLabel
        icon={
          currentStep?.title === additionalStepTitle ? (
            <Edit style={{ color: '#00ACC1' }} />
          ) : (
            <DescriptionIcon style={{ color: theme.palette.secondary.main }} />
          )
        }
        style={{
          cursor: isTitleClickable ? 'pointer' : 'default',
        }}
        aria-label={`Step ${additionalStepTitle}`}
        aria-disabled="false"
        tabIndex={0}
        onClick={() => {
          if (isTitleClickable) setActiveStep(steps.length);
        }}
      >
        {!isCollapsed && (
          <Typography
            variant="body1"
            component="h3"
            style={{
              background:
                currentStep?.title === additionalStepTitle
                  ? theme.palette.bkg.primary
                  : 'none',
              padding: '4px',
              borderRadius: '2px',
            }}
          >
            {additionalStepTitle}
          </Typography>
        )}
      </StepLabel>
    </StepUI>
  );

  return (
    <Stepper
      style={{
        background: theme.palette.background.default,
        ...rootStepperStyle,
      }}
      activeStep={activeStep}
      orientation="vertical"
      ref={ref}
      connector={<StepConnector />}
    >
      {steps.map(({ title }, index) => {
        return (
          <StepUI key={title} active={currentStep?.title === title}>
            <StepLabel
              icon={
                currentStep?.title === title ? (
                  <Edit style={{ color: '#00ACC1' }} />
                ) : (
                  <div
                    style={{
                      borderRadius: '100%',
                      background: theme.palette.bkg.primary,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <ChevronRight
                      style={{ color: theme.palette.secondary.main }}
                    />
                  </div>
                )
              }
              style={{
                cursor: isTitleClickable ? 'pointer' : 'default',
              }}
              aria-label={`Step ${index + 1} ${title}`}
              aria-disabled="false"
              tabIndex={0}
              onClick={() => {
                if (isTitleClickable) setActiveStep(index);
              }}
            >
              {!isCollapsed && (
                <Typography
                  variant="body1"
                  component="h3"
                  style={{
                    background:
                      currentStep?.title === title
                        ? theme.palette.bkg.primary
                        : 'none',
                    padding: '4px',
                    borderRadius: '2px',
                  }}
                >
                  {title}
                </Typography>
              )}
            </StepLabel>
          </StepUI>
        );
      })}
      {additionalStep}
    </Stepper>
  );
};
